export default __webpack_public_path__ + "static/accents-color-accessibility-light-5482e9b281486667a14312a97c2c5e62f4e10e27769bfea6e92fa75734c7fa65.png";